import { SVGProps } from 'react'

const ChevronLeftIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M10.5 12.5L6.5 8.5L10.5 4.5'
                stroke='#959699'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default ChevronLeftIcon
